// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-alert {
  position: fixed;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);
  background: #fdecea; /* light red background */
  border: 2px solid #d93025; /* stronger red border */
  color: #d93025; /* stronger red text */
  padding: 12px 20px;
  border-radius: 6px;
  z-index: 5000;
  box-shadow: 0 6px 18px rgba(217, 48, 37, 0.12);
  font-weight: 600;
  font-size: 14px;
  max-width: 90%;
  text-align: center;
  transition: transform 0.28s ease, opacity 0.28s ease;
}

/* Optional subtle entry animation */
.top-alert.show {
  transform: translateX(-50%) translateY(0);
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/TopAlert.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,mBAAmB,EAAE,yBAAyB;EAC9C,yBAAyB,EAAE,wBAAwB;EACnD,cAAc,EAAE,sBAAsB;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA,oCAAoC;AACpC;EACE,yCAAyC;EACzC,UAAU;AACZ","sourcesContent":[".top-alert {\n  position: fixed;\n  top: 70px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #fdecea; /* light red background */\n  border: 2px solid #d93025; /* stronger red border */\n  color: #d93025; /* stronger red text */\n  padding: 12px 20px;\n  border-radius: 6px;\n  z-index: 5000;\n  box-shadow: 0 6px 18px rgba(217, 48, 37, 0.12);\n  font-weight: 600;\n  font-size: 14px;\n  max-width: 90%;\n  text-align: center;\n  transition: transform 0.28s ease, opacity 0.28s ease;\n}\n\n/* Optional subtle entry animation */\n.top-alert.show {\n  transform: translateX(-50%) translateY(0);\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
